<div [class]="visible ? 'flex flex-col h-full' : 'hidden'">
  <div class="card-body flex grow flex-col">
    <div class="flex">
      <p-button size="small" label="Apply Kits to Program" icon="pi pi-plus" (click)="onApply()"
        [disabled]="parent.isReadOnly()"></p-button>
    </div>
    <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[45, 55]">
      <ng-template pTemplate>
        <div class="flex w-full h-full grow">
          <div class="flex-col pt-2 pb-2 w-2/3 h-full">
            <prox-ag-grid [gridOptions]="kitsGridOptions" [rowData]="programKits"></prox-ag-grid>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate>
        <p-splitter class="w-full" layout="vertical" [panelSizes]="[55, 45]">
          <ng-template pTemplate>
            <div class="flex-col w-full h-full">
              <prox-ag-grid [gridOptions]="kitDetailsGridOptions" [rowData]="kitDetails"></prox-ag-grid>
            </div>
          </ng-template>
        </p-splitter>
      </ng-template>
    </p-splitter>
  </div>
</div>